// Category pills: one per category whose section actually renders (it has a
// sellable item). A category holding only items off the online channel —
// e.g. one a platform import created for platform-only items — gets none.
//
// Each pill keeps its category's index in the FULL list: the section refs
// are indexed that way, so a hidden pill must not shift the ones after it.

export type PillCategory = { categoryId: string; categoryText: string; deleted?: boolean; disabled?: boolean };

export function categoryPills<C extends PillCategory>(categories: C[], products: any[]): (C & { index: number })[] {
    return categories
        .map((c, index) => ({ ...c, index }))
        .filter((c) => !c.deleted && !c.disabled && products.some((p) =>
            p.category === c.categoryId && p.productType !== "additional" && !p.isDisabled && !p.isDeleted));
}
